import React from 'react';

// Palette usa as CSS vars → respeita whitelabel quando color=primary/secondary.
const COLOR = {
  primary: {
    solid: 'bg-primary text-white',
    soft: 'bg-primary/10 text-primary',
    outline: 'border border-primary text-primary bg-transparent',
    dot: 'bg-primary',
  },
  secondary: {
    solid: 'bg-secondary text-white',
    soft: 'bg-secondary/10 text-secondary',
    outline: 'border border-secondary text-secondary bg-transparent',
    dot: 'bg-secondary',
  },
  success: {
    solid: 'bg-success text-white',
    soft: 'bg-success/10 text-success',
    outline: 'border border-success text-success bg-transparent',
    dot: 'bg-success',
  },
  warning: {
    solid: 'bg-warning text-white',
    soft: 'bg-warning/10 text-warning',
    outline: 'border border-warning text-warning bg-transparent',
    dot: 'bg-warning',
  },
  error: {
    solid: 'bg-error text-white',
    soft: 'bg-error/10 text-error',
    outline: 'border border-error text-error bg-transparent',
    dot: 'bg-error',
  },
  info: {
    solid: 'bg-info text-white',
    soft: 'bg-info/10 text-info',
    outline: 'border border-info text-info bg-transparent',
    dot: 'bg-info',
  },
  neutral: {
    solid: 'bg-gray-600 text-white',
    soft: 'bg-gray-100 text-gray-700',
    outline: 'border border-gray-400 text-gray-700 bg-transparent',
    dot: 'bg-gray-500',
  },
};

const SIZE = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
};

const Badge = ({
  children,
  color = 'neutral',
  variant = 'soft',
  size = 'sm',
  leftIcon,
  dot = false,
  className = '',
}) => {
  const colorStyles = COLOR[color] || COLOR.neutral;
  const variantStyle = colorStyles[variant] || colorStyles.soft;
  const sizeStyle = SIZE[size] || SIZE.sm;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium whitespace-nowrap ${variantStyle} ${sizeStyle} ${className}`}
    >
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${colorStyles.dot}`} />}
      {leftIcon && <span className="inline-flex">{leftIcon}</span>}
      {children}
    </span>
  );
};

export default Badge;
